.input-field-wrapper {
  align-items: center;
  display: flex;
  position: relative;
}

.input-field {
  appearance: none;
  background-color: transparent;
  border: 1px solid;
  border-radius: 0.5rem;
  color: var(--color-uva-black);
  flex: 1;
  font-family: inherit;
  font-size: inherit;
  height: 2.75rem;
  margin: 0;
  padding: 0 1rem;
  text-align: inherit;
}

.input-field--large {
  height: 3rem;
}

.input-field--small {
  max-width: 5.25rem;
}

.input-field--compact {
  max-width: 6.25rem;
}

.input-field--white {
  background-color: var(--color-uva-white);
}

.input-field--not-valid {
  border-color: var(--color-red-600);
}

.input-field:disabled {
  color: var(--color-grey-700);
}

.input-field__clear-button {
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 100%;
  padding: 0 1rem 0 0.5rem;
  position: absolute;
  right: 0;
}
